import React from 'react'
import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native'
import { useLocalSearchParams, useRouter } from 'expo-router'
import { posts } from '@/content/blog/posts'
import Seo from '@/components/Seo'
import BlogCTA from '@/components/BlogCTA'
import { useTheme } from '@/contexts/ThemeContext'
import '@/styles/blog.css'

const BASE_URL = 'https://poenoracha.com.br'

export default function BlogPostPage() {
  const { slug } = useLocalSearchParams<{ slug: string }>()
  const post = posts.find((p) => p.slug === slug)
  const { colors } = useTheme()
  const router = useRouter()
  const formatDateBR = (s: string) => {
    const [y, m, d] = s.split('-')
    return `${d}/${m}/${y}`
  }

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    header: {
      paddingHorizontal: 24,
      paddingVertical: 24,
      gap: 8,
    },
    nav: {
      flexDirection: 'row',
      gap: 12,
      alignItems: 'center',
      marginBottom: 8,
    },
    navBtn: {
      paddingHorizontal: 12,
      paddingVertical: 8,
      borderRadius: 10,
      backgroundColor: colors.border,
    },
    navBtnText: {
      fontSize: 12,
      fontFamily: 'Inter-SemiBold',
      color: colors.text,
    },
    title: {
      fontSize: 26,
      fontFamily: 'Inter-Bold',
      color: colors.text,
    },
    meta: {
      fontSize: 12,
      fontFamily: 'Inter-Regular',
      color: colors.textSecondary,
    },
    cover: {
      width: '100%',
      height: 'auto' as any,
      aspectRatio: 3000 / 1150,
      objectFit: 'cover' as any,
      marginTop: 12,
      borderRadius: 12,
    },
    content: {
      paddingHorizontal: 24,
      paddingBottom: 40,
    },
    markdown: {
      color: colors.text,
      fontFamily: 'Inter-Regular',
      lineHeight: 24,
      fontSize: 16,
    } as any,
  })

  if (!post) {
    return (
      <ScrollView style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.title}>Artigo não encontrado</Text>
          <Text style={styles.meta}>Verifique o link e tente novamente.</Text>
        </View>
      </ScrollView>
    )
  }

  return (
    <ScrollView style={styles.container} contentContainerStyle={{ paddingBottom: 40 }}>
      <Seo
        title={`${post.title} | Põe no Racha`}
        description={post.description}
        image={post.coverImage}
        url={`${BASE_URL}/blog/${post.slug}`}
      />

      <View style={styles.header}>
        <View style={styles.nav}>
          <TouchableOpacity onPress={() => router.push('/blog')} style={styles.navBtn} activeOpacity={0.8}>
            <Text style={styles.navBtnText}>Blog</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={() => router.back()} style={styles.navBtn} activeOpacity={0.8}>
            <Text style={styles.navBtnText}>Voltar</Text>
          </TouchableOpacity>
        </View>
        <h1 style={{ ...(styles.title as any), margin: 0 }}>{post.title}</h1>
        <p style={{ ...(styles.meta as any), margin: 0 }}>{formatDateBR(post.date)}</p>
        {post.coverImage ? (
          <img
            src={post.coverImage}
            alt={`Capa do artigo: ${post.title}`}
            loading="eager"
            decoding="async"
            style={styles.cover as any}
          />
        ) : null}
      </View>

      <View style={styles.content}>
        <div className="markdown" style={{ color: colors.text }} dangerouslySetInnerHTML={{ __html: post.contentHtml }} />
        <BlogCTA />
      </View>
    </ScrollView>
  )
}
